import React from "react"
import PropTypes from "prop-types"

import { Trans } from "gatsby-plugin-react-i18next"

import * as simpleBlogLatestSectionFiltersStyles from "../styles/SimpleBlogLatestSectionFilters.module.css"

import metadataFilters from "./config/SimpleBlogLatestFiltersCfg.json"

const hasFiltersOfType = (allFilters, filters, type) => {
  if (!filters || !filters.length) return false

  const typeFilters = allFilters[type]
    .filter(f => f.kind === `category`)
    .map(f => f.label.toLowerCase())

  return filters.reduce(
    (acc, curr) => acc || typeFilters.includes(curr.toLowerCase()),
    false,
  )
}

const grouppedFilters = (metadataFilters, cat, props, subCategory = null) => {
  const filters = metadataFilters[cat].filter(
    f =>
      !props.overrideFilters ||
      props.overrideFilters.length === 0 ||
      (props.overrideFilters &&
        props.fixedFilters.includes(f.label.toLowerCase().replace(` `, `-`))) ||
      props.overrideFilters.includes(f.label.toLowerCase().replace(` `, `-`)),
  )

  if (subCategory)
    return filters.filter(
      f => f.group === subCategory || subCategory === `NO_SUB_CATEGORY`,
    )

  let groups
  if (filters[0] && filters[0].group) {
    groups = filters.reduce(
      (hash, obj) => ({
        ...hash,
        [obj[`group`]]: (hash[obj[`group`]] || []).concat(obj),
      }),
      {},
    )
  } else {
    groups = { NO_SUB_CATEGORY: filters }
  }

  return groups
}

const mappedFilter = filter => {
  /* if (filter.toLowerCase() === `software` || filter.toLowerCase() === `code` || filter.toLowerCase() === `technical`)
    return `code` */

  return filter.toLowerCase()
}

const translatedFilter = filter => {
  if (filter.toLowerCase() === `software` || filter.toLowerCase() === `code` || filter.toLowerCase() === `technical`)
    return `Software`

  return filter
}

function SimpleBlogLatestSectionFilters(props) {
  const hasProductFilters = hasFiltersOfType(
    metadataFilters,
    props.fixedFilters,
    `Products`,
  )
  const hasContentTypeFilters = hasFiltersOfType(
    metadataFilters,
    props.fixedFilters,
    `Content Type`,
  )

  const hasProductFilterOverrides = hasFiltersOfType(
    metadataFilters,
    props.overrideFilters,
    `Products`,
  )
  const hasContentTypeFilterOverrides = hasFiltersOfType(
    metadataFilters,
    props.overrideFilters,
    `Content Type`,
  )

  if (
    hasProductFilters &&
    hasContentTypeFilters &&
    !hasProductFilterOverrides &&
    !hasContentTypeFilterOverrides
  )
    return <></>

  return (
    <div className={`row ${simpleBlogLatestSectionFiltersStyles.filters}`}>
      {Object.keys(metadataFilters)
        .filter(
          cat =>
            !hasFiltersOfType(metadataFilters, props.fixedFilters, cat) ||
            hasFiltersOfType(metadataFilters, props.overrideFilters, cat),
        )
        .map((cat, idx) => (
          <div
            key={idx}
            className={`col-12`}
            style={{
              visibility: props.settingsLoaded ? `visible` : `hidden`,
            }}
          >
            <p className={simpleBlogLatestSectionFiltersStyles.filterCategory}>
              {cat}
            </p>

            {Object.keys(grouppedFilters(metadataFilters, cat, props)).map(
              (subCategory, idx) => (
                <span key={idx}>
                  <div className={`row`}>
                    <div
                      className={`col-12 ${simpleBlogLatestSectionFiltersStyles.filtersGrid2}`}
                    >
                      <span
                        className={`row ${simpleBlogLatestSectionFiltersStyles.filterSelectorSubCategory}`}
                      >
                        <h6>
                          <Trans>
                            {subCategory !== `NO_SUB_CATEGORY` && subCategory}
                          </Trans>
                        </h6>
                      </span>
                    </div>
                  </div>
                  <div className={`row`}>
                    <div
                      className={`col-12 ${simpleBlogLatestSectionFiltersStyles.filtersGrid}`}
                    >
                      {grouppedFilters(
                        metadataFilters,
                        cat,
                        props,
                        subCategory,
                      ).map((filter, indx) => (
                        <span
                          key={indx}
                          className={`row ${simpleBlogLatestSectionFiltersStyles.filterSelector}`}
                        >
                          <label>
                            <input
                              type="checkbox"
                              disabled={
                                props.fixedFilters &&
                                props.fixedFilters.includes(
                                  filter.label.toLowerCase(),
                                )
                              }
                              checked={
                                props.selectedFilters &&
                                props.selectedFilters.includes(
                                  filter.label.toLowerCase(),
                                )
                              }
                              onChange={() => {
                                if (filter.kind === `category`)
                                  props.onCategoryFilterToggle(
                                    mappedFilter(filter.label),
                                  )
                                if (filter.kind === `tag`)
                                  props.onTagFilterToggle(
                                    mappedFilter(filter.label),
                                  )
                              }}
                            />
                            {translatedFilter(filter.label)}
                          </label>
                        </span>
                      ))}
                    </div>
                  </div>
                </span>
              ),
            )}
            {/* .map(
                  (filter, indx) => (
                    <span
                      key={indx}
                      className={`row ${simpleBlogLatestSectionFiltersStyles.filterSelector}`}
                    >
                      <label>
                        <input
                          type="checkbox"
                          disabled={
                            props.fixedFilters &&
                            props.fixedFilters.includes(
                              filter.label.toLowerCase()
                            )
                          }
                          checked={
                            props.selectedFilters &&
                            props.selectedFilters.includes(
                              filter.label.toLowerCase()
                            )
                          }
                          onChange={() => {
                            if (filter.kind === `category`)
                              props.onCategoryFilterToggle(
                                filter.label.toLowerCase()
                              )
                            if (filter.kind === `tag`)
                              props.onTagFilterToggle(
                                filter.label.toLowerCase()
                              )
                          }}
                        />
                        <strong>{filter.group}</strong> - {filter.label}
                      </label>
                    </span>
                  )
                )} */}
          </div>
        ))}
    </div>
  )
}

SimpleBlogLatestSectionFilters.propTypes = {
  settingsLoaded: PropTypes.bool.isRequired,
  fixedFilters: PropTypes.array.isRequired,
  selectedFilters: PropTypes.array.isRequired,
  onCategoryFilterToggle: PropTypes.func.isRequired,
  onTagFilterToggle: PropTypes.func.isRequired,
}

export default SimpleBlogLatestSectionFilters
